import { render, staticRenderFns } from "./ModeSelector.vue?vue&type=template&id=d87f85d2&scoped=true"
import script from "./ModeSelector.vue?vue&type=script&lang=js"
export * from "./ModeSelector.vue?vue&type=script&lang=js"
import style0 from "./ModeSelector.vue?vue&type=style&index=0&id=d87f85d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87f85d2",
  null
  
)

export default component.exports